import '../../sass/pages/_login.scss'
import * as Bouncer from 'formbouncerjs'
//import SplitText from "../components/SplitText"
const emails = ['temp-mail.org', 'correotemporal.org', 'mohmal.com', 'yopmail.com', 'tempail.com', 'emailondeck.com', 'emailtemporalgratis.com', 'crazymailing.com', 'tempr.email', 'bupmail.com', 'guerrillamail.com', 'temp-mail.io', 'es.emailfake.com', 'nowmymail.com', '10minutemail.net', 'es.getairmail.com', 'mailf5.com', 'flashmail.it', '10minemail.com', 'mailcatch.com', 'temp-mails.com', 'spambox.us', 'mailnull.com', 'incognitomail.com', 'ssl.trashmail.net', 'trashmail.net', 'mailinator.com', 'tempinbox.com', 'filzmail.com', 'dropmail.me', 'spam4.me', 'cs.email', 'one-off.email', 'throwawaymail.com', 'emailtemporal.org', 'maildrop.cc', 'mailforspam.com', 'trashmail.com', 'teleworm.us', 'superrito.com', 'rhyta.com', 'jourrapide.com', 'gustr.com', 'fleckens.hu', 'einrot.com', 'cuvox.de', 'dayrep.com', 'muyoc.com', 'buxod.com', 'pidox.org', 'mecip.net', 'pudxe.com', 'xedmi.com', 'ludxc.com', 'juzab.com', 'klepf.com', 'matra.site', 'bombamail.icu', 'yermail.net', 'totallynotfake.net', 'techblast.ch', 'spamthis.network', 'spammy.host', 'spammer.fail', 'shadap.org', 'pewpewpewpew.pw', 'netcom.ws', 'itcompu.com', 'disposable.site', 'deinbox.com', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.org', 'guerrillamail.net', 'guerrillamail.de', 'guerrillamail.biz', 'grr.la', 'netmail.tk', 'laste.ml', 'firste.ml', 'zeroe.ml', 'supere.ml', 'emlhub.com', 'emlpro.com', 'emltmp.com', 'yomail.info', '10mail.org', 'wegwerfmail.org', 'wegwerfmail.net', 'wegwerfmail.de', 'trashmail.me', 'trashmail.io', 'trashmail.at', 'trash-mail.at', 'rcpt.at', 'proxymail.eu', 'objectmail.com', 'kurzepost.de', 'damnthespam.com', 'contbay.com', '0box.eu', 'marmaryta.space', '5y5u.com', '58as.com', 'firemailbox.club', 'mozej.com', 'mailna.co', 'mailna.in', 'mailna.me', 'mohmal.im', 'mohmal.in', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'nedoz.com', 'nmagazinec.com', 'armyspy.com', 'vmani.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'spambog.com', 'spambog.de', 'spambog.ru', '0btcmail.pw', '815.ru', 'knol-power.nl', 'hartbot.de', 'freundin.ru', 'smashmail.de', 's0ny.net', 'pecinan.net', 'budaya-tionghoa.com', 'lajoska.pe.hu', '1mail.x24hr.com', 'from.onmypc.info', 'now.mefound.com', 'mowgli.jungleheart.com', 'yourspamgoesto.space', 'pecinan.org', 'budayationghoa.com', 'CR.cloudns.asia', 'TLS.cloudns.asia', 'MSFT.cloudns.asia', 'B.cr.cloUdnS.asia', 'ssl.tls.cloudns.ASIA', 'sweetxxx.de', 'DVD.dns-cloud.net', 'DVD.dnsabr.com', 'BD.dns-cloud.net', 'YX.dns-cloud.net', 'SHIT.dns-cloud.net', 'SHIT.dnsabr.com', 'eu.dns-cloud.net', 'eu.dnsabr.com', 'asia.dnsabr.com', '8.dnsabr.com', 'pw.8.dnsabr.com', 'mm.8.dnsabr.com', '23.8.dnsabr.com', 'pecinan.com', 'disposable-email.ml', 'pw.epac.to', 'postheo.de', 'sexy.camdvr.org', 'Disposable.ml', '888.dnS-clouD.NET', 'adult-work.info', 'casinokun.hu', 'bangsat.in', 'wallus.casinokun.hu', 'trap-mail.de', 'umailz.com', 'panchoalts.com', 'gmaile.design', 'ersatzauto.ch', 'tempes.gq', 'cpmail.life', 'tempemail.info', 'coolmailcool.com', 'kittenemail.com', '99email.xyz', 'notmyemail.tech', 'm.cloudns.cl', 'twitter-sign-in.cf', 'anonymized.org', 'you.has.dating', 'ketoblazepro.com', 'kost.party', '0hio0ak.com', '4dentalsolutions.com', 't.woeishyang.com', 'ondemandemail.top', 'kittenemail.xyz', 'blackturtle.xyz', 'y.x.ssl.cloudns.asia', 'geneseeit.com', 'mailg.ml', 'media.motornation.buzz', 'sage.speedfocus.biz', 'badlion.co.uk', 'safeemail.xyz', 'virtual-generations.com', 'new-york.host', 'mrdeeps.ml', 'kitela.work', 'fouadps.cf', 'megacorp.work', 'fake-wegwerf.email', 'tigytech.com', 'historictheology.com', 'ma.567map.xyz', 'hotmailproduct.com', 'maxsize.online', 'happyfreshdrink.com', 'denomla.com', 'pansamantala.poistaa.com', 'sahaltastari.sytes.net', 'cecep.ddnsking.com', 'fadilmalik.ddnsking.com', 'csingi.sytes.net', 'richmail.ga', 'tikmail.gq', 'bupkiss.ml', 'guerrillamail.info', 'pokemail.net', 'myinbox.icu', 'just4fun.me', 'inscriptio.in', 'cloud-mail.top', 'safemail.icu', 'montokop.pw', 'tempamailbox.info', 'blogtron.com', 'atanetorg.org', 'aristockphoto.com', 'jomcs.com', 'kukuka.org', 'gothill.com', 'mixely.com', 'marsoasis.org', 'walmarteshop.com', 'outlandlabs.com', 'comectrix.com', 'buymondo.com', 'eventao.com', 'louieliu.com', 'mymailnow.xyz', 'cuoly.com', 'getnada.com', 'abyssmail.com', 'boximail.com', 'clrmail.com', 'dropjar.com', 'getairmail.com', 'givmail.com', 'inboxbear.com', 'robot-mail.com', 'tafmail.com', 'vomoto.com', 'zetmail.com']
declare global {
    interface Window {
        dataLayer: any
    }
}
document.addEventListener('DOMContentLoaded', (event) => {
    validateForm()
    closeLoginModal()
    redirectAcceptModal()
    showPassword()
    //splitTextFun()
})


const splitTextFun = () => {
    //new SplitText('.mvm__login__info__top p')
}

const validateForm = () => {
    let validate = Bouncer('.form--login', {
        patterns: {
            email: /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
        },
        customValidations: {
            emailVerified: function (field: any ) {
              let array_email = field.value.split("@");
              const res = emails.find( m => m === array_email[1]);      
              return res === undefined ? false : true;
            },
        },
        messages: {
            missingValue: {
                default: 'Este campo es requerido.'
            },
            emailVerified : 'Por favor ingrese un email válido',
            patternMismatch:{
                email: 'Por favor ingrese un email válido',
            },
        }
    });

    // FOrgot PAssword Valdiate

    let validateForgot = Bouncer('.form--forgot', {
        patterns: {
            email: /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
        },
        customValidations: {
            emailVerified: function (field: any ) {
              let array_email = field.value.split("@");
              const res = emails.find( m => m === array_email[1]);      
              return res === undefined ? false : true;
            },
        },
        messages: {
            missingValue: {
                default: 'Este campo es requerido.'
            },
            emailVerified : 'Por favor ingrese un email válido',
            patternMismatch:{
                email: 'Por favor ingrese un email válido',
            },
        }
    });

    let validateChange = Bouncer('.form--changePass', {
        customValidations: {
            confirmPass: (field: any) => {
                if (field.name == 'verify_password') {
                    const password = document.querySelector('#edit-password') as any
                    const value = field.value

                    if (password.value != value) {
                        return true;
                    }
                }
            },
            password: (field: any) => {
                if (field.name == 'password') {
                    const value = field.value

                    if (value.length < 8) {
                        return true;
                    }
                }
            }, 
        },
        messages: {
            missingValue: {
                default: 'Este campo es requerido.'
            },
            confirmPass: 'Ambas contraseñas deben coincidir',
            password: 'Ingrese una contraseña de minimo 8 caracteres'
        }
    })
    window.dataLayer = window.dataLayer || [];
    document.addEventListener('bouncerFormValid', function (event) {
        let email = document.getElementById('edit-email') as any
        let emailVal = email.value
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Login',
            'event_action': 'Submit',
            'event_label': `${emailVal}`,
        });
    }, false);

}

const closeLoginModal = () => {
    setTimeout(() => {
        let modal = document.querySelector('.mvm-modal--white')
        let close = modal?.querySelector('.mvm-modal-close')
        close?.addEventListener('click', e => {
            modal?.classList.add('is-close')
        })
    }, 300);
}

const redirectAcceptModal = () => {
    setTimeout(() => {
        let modal = document.querySelector('.mvm-modal--white')
        let accept = modal?.querySelector('.mvm-modal__register__actions a')
        accept?.addEventListener('click', e => {
            e.preventDefault()
            window.location.href = '/'
        })
    }, 300);
}

const showPassword = () => {
    let boxPass = document.querySelectorAll('.js-form-type-password')
    for (let index = 0; index < boxPass.length; index++) {
        const element = boxPass[index];
        let inputPass = element?.querySelector('input') as HTMLInputElement
        let showPass = document.createElement('div')
        showPass.className = 'form__boxPass__showPass'
        element?.appendChild(showPass)
        showPass.addEventListener('click', e => {
            if(inputPass?.type === "password"){
                inputPass.type = "text"
            } else{
                inputPass.type = "password"
            }
        })
    }
    return
    /*let inputPass = boxPass?.querySelector('input') as HTMLInputElement
    let showPass = document.createElement('div')
    showPass.className = 'form__boxPass__showPass'
    boxPass?.appendChild(showPass)
    showPass.addEventListener('click', e => {
        if(inputPass?.type === "password"){
            inputPass.type = "text"
        } else{
            inputPass.type = "password"
        }
    })*/

}